module.exports = __webpack_public_path__ + "img/map_thumb.c736b3b8.png";